import { render, staticRenderFns } from "./60qytea.vue?vue&type=template&id=fdb8f862&"
import script from "./60qytea.vue?vue&type=script&lang=js&"
export * from "./60qytea.vue?vue&type=script&lang=js&"
import style0 from "./60qytea.vue?vue&type=style&index=0&id=fdb8f862&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports